import { useLocale } from 'locale'
import { FormEvent, KeyboardEvent, useRef, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { IconSearch } from './icon-search'
import { Form, Input, SearchButton } from './styled'

export const Search = () => {
  const [value, setValue] = useState('')
  const [isOpen, setIsOopen] = useState(false)
  const inputRef = useRef<HTMLInputElement>(null)
  const navigate = useNavigate()
  const locale = useLocale()

  const handelSubmit = (evt: FormEvent) => {
    evt.preventDefault()

    if (value.trim()) {
      navigate(`/search/${encodeURIComponent(value)}`)
    }
  }

  const handleToggle = () => {
    setIsOopen(true)

    if (inputRef.current) {
      inputRef.current.focus()
    }
  }

  const handleCancel = (evt: KeyboardEvent<HTMLInputElement>) => {
    if (evt.code === 'Escape') {
      inputRef.current?.blur()
    }
  }

  return (
    <Form onSubmit={handelSubmit} isOpen={isOpen}>
      <Input
        value={value}
        type="text"
        placeholder={locale.searchPlaceholder}
        onChange={evt => setValue(evt.target.value)}
        onBlur={() => setIsOopen(false)}
        onKeyDown={handleCancel}
        ref={inputRef}
      />
      <SearchButton
        type={isOpen ? 'submit' : 'button'}
        onClick={isOpen ? undefined : handleToggle}
      >
        <IconSearch />
      </SearchButton>
    </Form>
  )
}
